module.exports = __webpack_public_path__ + "static/img/codeicon2.f6373a22.svg";